import { customerActionPath } from '@helpers/variables'
import { CUSTOMER_ACTIONS } from '@helpers/constants'
import { getCookie } from '@helpers/utilities'
import { mutate } from 'swr'
import { Current_User } from '@graphql/queries'

const useCustomerAction = () => {
  const trackCustomerAction = async (action) => {
    const csrfToken = document.querySelector('meta[name=csrf-token]')

    if (csrfToken && action) {
      // Special case for DAILY_VISIT, only allowed once per day
      if (action === CUSTOMER_ACTIONS.DAILY_VISIT) {
        const cookieName = 'daily_visit'
        const cookieValue = 'done'
        const cookie = getCookie(cookieName)

        if (cookie && cookie === cookieValue) {
          // cookie is set, bail out
          return
        }

        const expiresAtMidnight = new Date()
        expiresAtMidnight.setHours(23, 59, 59, 0)

        document.cookie = `${cookieName}=${cookieValue}; path=/; expires=${expiresAtMidnight}`
      }

      const formData = new FormData()
      formData.append('action', action)

      const headers = new Headers({
        'X-CSRF-TOKEN': csrfToken.content,
      })

      const res = await fetch(customerActionPath, {
        method: 'POST',
        headers: headers,
        body: formData,
      })

      if (res.ok) {
        mutate(Current_User)
      }

      const result = await res.json()
      // console.log('🚀 ~ trackCustomerAction, result', result)
    }
  }

  return {
    trackCustomerAction,
  }
}

export { useCustomerAction }
